import React, { FC } from 'react'
import { Category } from '@lib/api'
import { useUI } from '@components/ui'
import { SidebarView } from '@components/common/Layout/SidebarView'

// TODO: this component can be removed and SidebarView can be used directly

export const SidebarUI: FC<{
  menuCategories: Category[]
  sizeGuideURL?: string
}> = ({ menuCategories, sizeGuideURL }) => {
  const { displaySidebar, closeSidebar, sidebarView } = useUI()

  return (
    <SidebarView
      sidebarIsShown={displaySidebar}
      sidebarView={sidebarView}
      closeSidebar={closeSidebar}
      menuCategories={menuCategories}
      sizeGuideURL={sizeGuideURL}
    />
  )
}
